export default __webpack_public_path__ + "static/kuhmichel-5a1d4948c297781838cfbfe9d739638a.jpg";